import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cget = (k) => {
  try { return JSON.parse(localStorage.getItem(k) || "null"); } catch { return null; }
};
const cset = (k, v) => {
  try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* ignore */ }
};

/**
 * useCached — read the last known-good response from localStorage synchronously
 * (no flash of default text on repeat visits), then refresh from the API and
 * update the cache. On the very first visit the state is `initial` until the
 * API resolves.
 */
export function useCached(url, cacheKey, initial = null) {
  const [data, setData] = useState(() => {
    const c = cget(cacheKey);
    return c === null ? initial : c;
  });
  useEffect(() => {
    let stop = false;
    api.get(url).then(({ data: d }) => {
      if (stop) return;
      setData(d);
      cset(cacheKey, d);
    }).catch(() => {});
    return () => { stop = true; };
  }, [url, cacheKey]);
  return data;
}

export { cget, cset };
